































import { defineComponent, PropType } from '@vue/composition-api'

interface ContinuousInfo {
    /** 签约状态。0 - 未签约； 1 - 已签约，正在生效 */
    continuous_status?: number
    /** 套餐名称 */
    name?: string
    /** 下次续费时间 */
    next_deduction_time?: string
    /** 套餐价格，单位为分 */
    price?: number
}

export default defineComponent({
  name: 'RenewalOrder',
  props: {
    continuousInfo: {
      type: Object as PropType<ContinuousInfo>,
      default: () => {
        return {
          /** 签约状态。0 - 未签约； 1 - 已签约，正在生效 */
          continuous_status: 0,
          /** 套餐名称 */
          name: undefined,
          /** 下次续费时间 */
          next_deduction_time: undefined,
          /** 套餐价格，单位为分 */
          price: undefined
        }
      }
    }
  },
  setup (props) {
    function formatPrice (price: number) {
      if (price) {
        return Math.floor(price / 100) + '元'
      }
      return '-'
    }
    return {
      props,
      formatPrice
    }
  }
})
